export default __webpack_public_path__ + "static/media/Illustration5.af826568.png";